"use strict";
/**
 * Created by Ning Jiang on 11/7/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemEvent = void 0;
class SystemEvent {
}
SystemEvent.SHOW_DIALOG = "systemEvent_showDialog";
SystemEvent.CONFIG_LOADED = "systemEvent_configLoaded";
exports.SystemEvent = SystemEvent;
//# sourceMappingURL=SystemEvent.js.map